<ng-template let-item="item">
    <span class="font-weight-bold">Saját szűrésem</span>
</ng-template>
